import TableCellSpace from "ds/components/Table/Row/CellSpace";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { VcsIntegrationUser } from "types/generated";

const IntegrationsVcsUsedByTableSpaceCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<VcsIntegrationUser>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellSpace href={`/spaces/${item.spaceDetails.id}`}>
        {item.spaceDetails.name}
      </TableCellSpace>
    </TableSimpleCell>
  );
};

export default IntegrationsVcsUsedByTableSpaceCell;
